<template>
  <div class="mapSearch">
    <!-- 返回首页 -->
    <div class="backHome">
      <el-tooltip effect="dark" content="返回首页" placement="right">
        <el-button class="backHomeBtn" icon="el-icon-s-home" circle @click="backHomeFun"></el-button>
      </el-tooltip>
    </div>
    <!-- 拉起查询按钮 -->
    <div class="searchBtnBox">
      <el-button
        class="changeBtn"
        type="primary"
        :icon="iconSrc"
        @click="modelChange"
        :loading="changeState"
        >条件筛选</el-button
      >
      <!-- 关键字查询 -->
      <div class="userInputWord"  v-if="!currentState">
        <el-input
        placeholder="请输入产品名称查询"
        v-model="keyWordVal"
        clearable>
      </el-input>
      </div>
      
      <el-tooltip effect="dark" content="搜索产品" placement="right">
        <el-button
          v-if="!currentState"
          class="searchBtn"
          icon="el-icon-search"
          :loading="searchLoadState"
          circle
          @click="searchProduct"
        ></el-button>
      </el-tooltip>
    </div>
    <!-- 查询条件选择 -->
    <div class="searchMap" :class="currentState ? 'animateLeft' : ''">
      <!-- 切换查询方式 -->
      <div class="changeSearch">
        <div class="changeTabbar">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="行政区域" name="xzqh">行政区域</el-tab-pane>
            <el-tab-pane label="经纬度" name="jwd">经纬度</el-tab-pane>
          </el-tabs>
        </div>
        <div class="block">
          <el-carousel
            ref="carousel"
            trigger="click"
            height="140px"
            :autoplay="false"
            :loop="false"
            arrow="never"
            indicator-position="none"
          >
            <el-carousel-item v-for="(item, index) in searchCondition" :key="index">
              <div class="conditionCont">
                <div v-if="item.id == '1'">
                  <cityLinkage @cityValue="acceptCityValue"></cityLinkage>
                </div>
                <div v-else class="jwWrap">
                  <div class="selectItem">
                    <span class="selectItemName">经度（左）：</span>
                    <el-input
                      class="inputItem"
                      placeholder="0"
                      @on-change="longLatfn"
                      v-model="jwJson.jdTopValue"
                      clearable
                    >
                    </el-input>
                  </div>
                  <div class="selectItem">
                    <span class="selectItemName">经度（右）：</span>
                    <el-input
                      class="inputItem"
                      placeholder="0"
                      @on-change="longLatfn"
                      v-model="jwJson.jdBottomValue"
                      clearable
                    >
                    </el-input>
                  </div>
                  <div class="selectItem">
                    <span class="selectItemName">纬度（上）：</span>
                    <el-input
                      class="inputItem"
                      placeholder="0"
                      @on-change="longLatfn"
                      v-model="jwJson.wdTopValue"
                      clearable
                    >
                    </el-input>
                  </div>
                  <div class="selectItem">
                    <span class="selectItemName">纬度（下）：</span>
                    <el-input
                      class="inputItem"
                      placeholder="0"
                      @on-change="longLatfn"
                      v-model="jwJson.wdBottomValue"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="dataGetTime">
          <span class="dataGetTimeName">采集时间：</span>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="collectionTime"
            @change="collectEventFun"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="dataProductLevel">
          <span class="productLevelName">产品级别：</span>
          <el-select v-model="productLevel" clearable placeholder="请选择" @change="satelliteLevelFun">
            <el-option
              v-for="item in productLevelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="dataCloudiness">
          <span class="cloudinessName">云量：</span>
          <el-slider class="currentClond" v-model="cloudinessValue" @change="changeClundFun"></el-slider>
        </div>
        <div class="resolving">
          <span class="resolvingName">分辨率：</span>
          <el-checkbox-group v-model="checkList" @change="changeResolving">
            <el-checkbox v-for="(item,index) in satelliteResolve" :key="index" :label="item.value">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="otherResolve">
          <span class="resolvingName">其他分辨率：</span>
          <div class="inputBox">
            <span>&lt;=</span>
            <el-input
              v-model="otherResolveValue"
              placeholder="0"
              @input="changeOtherResolve"
            ></el-input>
            <span>m</span>
          </div>
        </div>
      </div>
      <!-- 卫星系列 -->
      <div class="satelliteWrap">
        <satelliteList :currentResolve="checkList" :data="satelliteAllData"></satelliteList>
      </div>
    </div>
  </div>
</template>

<script>
import satelliteList from "@/components/satellite.vue";
import cityLinkage from "@/components/cityLinkage.vue";
export default {
  name: "mapSearch",
  components: {
    satelliteList,
    cityLinkage
  },
  props:{
    // 搜索按钮状态
    searchResult:{
      type:Boolean,
      default:false
    },
    searchResultTool:{
      type:Boolean,
      default:false
    },
    searchId:{
      type:Array,
      default:[]
    },
    searchWord:{
      type:String,
      default:''
    }
  },
  watch:{
    // 搜索按钮状态切换
    searchResult:{
      handler(newVal,oldVal){
        // console.log(newVal,oldVal);
        console.log('查询结果回调按钮状态');
        if(newVal !== oldVal){
          this.searchLoadState = false;
        }
      }
    },
    searchResultTool:{
      handler(newVal,oldVal){
        // console.log(newVal,oldVal);
        console.log('地图工具触发查询按钮状态');
        this.searchLoadState = true;
        
      }
    },
    searchId:{
      handler(newVal,oldVal){
        console.log('跳转查询参数id集合：',newVal);
        if(newVal.length != 0){
          this.searchProduct();
        }
      },
      deep:true
    },
    searchWord:{
      handler(newVal,oldVal){
        console.log('跳转查询参数关键字集合：',newVal);
        this.keyWordVal = newVal;
        this.searchProduct();
      },
      deep:true
    }
  },
  data() {
    return {
      searchLoadState:false,
      iconSrc: "el-icon-s-fold",
      changeState: false,
      currentState: false,
      activeName: "xzqh",
      searchCondition: [
        { id: "1", text: "行政区域", eng: "xzqh" },
        { id: "2", text: "经纬度", eng: "jwd" },
      ],
      // 省市区编码
      cityCode:{
        provinceValue:'',
        cityValue:'',
        areaValue:''
      },
      // 经纬度
      jwJson: {
        jdTopValue: "",
        jdBottomValue: "",
        wdTopValue: "",
        wdBottomValue: "",
      },
      // 产品分辨率
      satelliteResolve:[
        {name:'0.5m',value:'0.5'},
        {name:'1m',value:'1'},
        {name:'2m',value:'2'},
        {name:'8m',value:'8'},
        {name:'16m',value:'16'},
      ],
      // 所有卫星系列数据
      satelliteAllData:[],
      // 数据采集时间
      collectionTime: "",
      // 产品级别列表
      productLevelList: [],
      // 产品级别值
      productLevel: "",
      // 云量
      cloudinessValue: 0,
      // 当前选中的分辨率
      checkList: [],
      // 其他分辨率
      otherResolveValue: "",
      //公共id
      publickID: "publickborderid",
      // 当前页面用户输入内容查询
      keyWordVal:""
    };
  },
  mounted() {
    // 获取卫星等级
    this.initSatelliteLevel();
    // 获取卫星类型
    this.initSatelliteType();
  },
  methods: {
    // 返回首页
    backHomeFun(){
      this.$router.push('RemoteSensingMall');
    },
    // 接受省市区参数
    acceptCityValue(value){
      console.log('当前操作的省市区信息：',value);
      
      switch(value.type){
        case 2:
          this.cityCode.provinceValue = value.value;
          break;
          case 3:
          this.cityCode.cityValue = value.value;
            break;
            case 4:
            this.cityCode.areaValue = value.value;
              break;
      }
    },
    // 修改产品等级
    satelliteLevelFun(e){
      console.log(e);
      console.log(this.productLevel);
      this.$store.dispatch('productSearch/updateProductLevel', e)
    },
    // 修改云量
    changeClundFun(e){
      console.log(e);
      console.log('当前云量：',this.cloudinessValue);
      this.$store.dispatch('productSearch/updateCloundNum', e)
    },
    // 经纬度输入
    longLatfn() {
      let border = [
        [Number(this.jwJson.jdTopValue), Number(this.jwJson.wdTopValue)],
        [Number(this.jwJson.jdBottomValue), Number(this.jwJson.wdTopValue)],
        [Number(this.jwJson.jdBottomValue), Number(this.jwJson.wdBottomValue)],
        [Number(this.jwJson.jdTopValue), Number(this.jwJson.wdBottomValue)],
        [Number(this.jwJson.jdTopValue), Number(this.jwJson.wdTopValue)],
      ];
      // this.addBorderLine(border);
    },
    // 搜索按钮
    searchProduct() {
      var jwInfo = '';
      console.log(this.activeName);
      if (this.activeName == "xzqh") {
        console.log('行政区划查询');
        this.jwJson.jdTopValue = '';
        this.jwJson.jdBottomValue = '';
        this.jwJson.wdTopValue = '';
        this.jwJson.wdBottomValue = '';
        jwInfo = '';
      } else if (this.activeName == "jwd") {
        console.log('经纬度查询');
        this.cityCode.provinceValue = '';
        this.cityCode.cityValue = '';
        this.cityCode.areaValue = '';
        let pointDataStr = Number(this.jwJson.jdTopValue) + " " + Number(this.jwJson.wdTopValue) + "," + Number(this.jwJson.jdBottomValue) + " " + Number(this.jwJson.wdTopValue) + ","+Number(this.jwJson.jdBottomValue)+" "+Number(this.jwJson.wdBottomValue)+","+Number(this.jwJson.jdTopValue)+" "+Number(this.jwJson.wdBottomValue)+","+Number(this.jwJson.jdTopValue)+" "+Number(this.jwJson.wdTopValue);
        jwInfo =  "POLYGON ((" + pointDataStr + "))";
      } else {
        console.log('默认查询');
      }
      let sendSearchParams = {
        pageNum:1,
        pageSize:5,
        // 省级code
        provinceId: this.cityCode.provinceValue,
        // 市级code
        cityId: this.cityCode.cityValue,
        // 区级code
        countyId: this.cityCode.areaValue,
        // 经纬度
        coordinateInfo:jwInfo,
        // 数据采集时间
        acquisitionStartTime: this.collectionTime[0]?this.collectionTime[0]:"",
        acquisitionEndTime:this.collectionTime[1]?this.collectionTime[1]:"",
        // 产品级别值
        productLevel:this.productLevel,
        // 云量
        cloudCover: this.cloudinessValue,
        // 当前选中的分辨率
        productDistinguishabilityList: this.checkList,
        // 其他分辨率
        // otherResolveValue: this.otherResolveValue,
        // 卫星系列
        satelliteCategoryIdList:this.$store.state.productSearch.satelliteMap,
        // 商品id列表
        goodsIds:this.searchId,
        // 商品关键字
        keyword:this.keyWordVal
      };
      this.searchLoadState = true;
      console.log("开启搜索参数：",sendSearchParams);
      this.$emit('startSearch',sendSearchParams);
      
    },
    // 条件筛选切换
    modelChange(e) {
      this.changeState = true;
      this.currentState = !this.currentState;
      if (this.currentState == true) {
        this.iconSrc = "el-icon-s-unfold";
      } else {
        this.iconSrc = "el-icon-s-fold";
      }
      setTimeout(() => {
        this.changeState = false;
      }, 500);
    },
    //   手动触发切换
    handleClick(tab, event) {
      if(tab.index == '1'){
         console.log('重置省市区');
        // 重置省市区
        this.cityCode.provinceValue = '';
        this.cityCode.cityValue = '';
        this.cityCode.areaValue = '';
        this.$store.dispatch("productSearch/updateQuerytype", "2");
      }else{
        console.log('重置经纬度');
        // 重置经纬度
        this.jwJson.jdTopValue = '';
        this.jwJson.jdBottomValue = '';
        this.jwJson.wdTopValue = '';
        this.jwJson.wdBottomValue = '';
        this.$store.dispatch("productSearch/updateQuerytype", "1");
      }
      // this.removeLayerById(this.publickID);
      this.$refs.carousel.setActiveItem(tab.index);
    },
    // 采集时间获取
    collectEventFun(value) {
      console.log("当前所选采集时间：", value);
    },
    // 分辨率选择
    changeResolving(value) {
      console.log(value);
      console.log("当前选择分辨率：", this.checkList);
      this.otherResolveValue = "";
      this.$store.dispatch("productSearch/updateResolution", value);
    },
    // 其他分辨率选择
    changeOtherResolve(value) {
      console.log("其他分辨率输入：", value);
      if (value || value.length > 0) {
        this.checkList = [];
        this.$store.dispatch("productSearch/updateResolution", this.checkList);
        this.$store.dispatch("productSearch/updateResolutions", value);
      }
    },
    initSatelliteLevel(){
      this.$http
        .get(this.$const.searchOther.satelliteLevel, "")
        .then((res) => {
          console.log("获取卫星等级:", res);
          if (res.code == 200) {
            res.data.map(item=>{
              let items = {
                value:item,
                lebal:item
              }
              this.productLevelList.push(items)
            })
          } else {
            this.$message.error(this.$PubText.getInfoFail);
          }
        })
        .catch((error) => {
          this.$message.error(this.$PubText.InterfaceFail);
        });
    },
    initSatelliteType(){
      this.$http
        .get(this.$const.searchOther.satelliteAll, "")
        .then((res) => {
          console.log("获取父级卫星分类:", res);
          if (res.code == 200) {
            this.satelliteAllData = res.data;
          } else {
            this.$message.error(this.$PubText.getInfoFail);
          }
        })
        .catch((error) => {
          this.$message.error(this.$PubText.InterfaceFail);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.mapSearch {
  .backHome {
    position: fixed;
    top: 20px;
    left: 2vh;
  }
  .searchBtnBox {
    width: 520px;
    height: 5vh;
    position: fixed;
    top: 10vh;
    left: 2vh;
    font-size: 14px;
    .userInputWord{
      width: 300px;
      display: inline-block;
      margin-left: 20px;
    }
      .searchBtn {
      float: right;
      margin-right: 10px;
      font-weight: bold;
    }
  }
  .animateLeft {
    left: -520px !important;
  }
  .searchMap {
    width: 520px;
    height: 70vh;
    position: fixed;
    background: rgba($color: #ffffff, $alpha: 0.8);
    top: 15vh;
    left: 2vh;
    overflow-y: auto;
    border-radius: 6px;
    transition: left ease-out 0.5s;
    -moz-transition: left ease-out 0.5s; /* Firefox 4 */
    -webkit-transition: left ease-out 0.5s; /* Safari and Chrome */
    -o-transition: left ease-out 0.5s; /* Opera */
    .changeSearch {
      padding: 5px;
      // background: rgba($color: #ffffff, $alpha: 0.6);
      .conditionCont {
        // background-color: aqua;
        font-size: 12px;
        overflow: hidden;
        padding-bottom: 2px;
        border-bottom: 1px solid #eee;
        .jwWrap {
          margin: 0 5px;
          .selectItem {
            margin: 4px auto;

            .selectItemName {
              display: inline-block;
              width: 100px;
              text-align: right;
              padding-right: 10px;
            }
            .inputItem {
              width: 200px;
              display: inline-block;
            }
          }
        }
      }
      .dataGetTime {
        font-size: 12px;
        margin-left: 5px;
        .dataGetTimeName {
          display: inline-block;
          width: 100px;
          text-align: right;
          padding-right: 10px;
        }
      }
      .dataProductLevel {
        font-size: 12px;
        margin-top: 10px;
        margin-left: 5px;
        .productLevelName {
          display: inline-block;
          width: 100px;
          text-align: right;
          padding-right: 10px;
        }
      }
      .dataCloudiness {
        font-size: 12px;
        margin-top: 10px;
        margin-left: 5px;
        .cloudinessName {
          display: inline-block;
          width: 100px;
          text-align: right;
          padding-right: 10px;
          line-height: 36px;
        }
        .currentClond {
          width: 260px;
          display: inline-block;
        }
      }
      .resolving {
        font-size: 12px;
        margin-top: 10px;
        margin-left: 5px;
        .resolvingName {
          display: inline-block;
          width: 100px;
          text-align: right;
          padding-right: 10px;
          line-height: 36px;
        }
        .el-checkbox-group {
          display: inline-block;
        }
      }
      .otherResolve {
        font-size: 12px;
        margin-top: 10px;
        margin-left: 5px;
        .resolvingName {
          display: inline-block;
          width: 100px;
          text-align: right;
          padding-right: 10px;
          line-height: 36px;
        }
        .inputBox {
          display: inline-block;
          font-size: 14px;
          .el-input {
            width: 40px;
            padding: 0;
          }
        }
      }
    }
    .satelliteWrap {
      padding: 5px;
      // background: rgba($color: #ffffff, $alpha: 0.6);
    }
  }
}
.changeSearch /deep/ .el-tabs__content {
  display: none !important;
}
.changeSearch /deep/ .addressWrap .el-input__inner {
  height: 32px !important;
}
.changeSearch /deep/ .jwWrap .el-input__inner {
  height: 26px !important;
}
.changeSearch /deep/ .otherResolve .el-input__inner {
  height: 26px !important;
  padding: 0;
  text-align: center;
}
.changeSearch /deep/ .dataGetTime .el-input__inner,
.changeSearch /deep/ .dataProductLevel .el-input__inner {
  height: 32px !important;
  font-size: 12px !important;
}
.changeSearch /deep/ .dataGetTime .el-date-editor.el-input__inner {
  width: 260px !important;
}
.changeSearch /deep/ .dataGetTime .el-date-editor .el-range-input {
  color: #9da0a7;
}
.changeSearch /deep/ .dataGetTime .el-date-editor .el-range-separator {
  color: #9da0a7;
  line-height: 26px !important;
  width: auto !important;
}
.changeSearch /deep/ .dataGetTime .el-date-editor .el-range__icon {
  line-height: 26px !important;
}
.changeSearch /deep/ .dataGetTime .el-date-editor .el-range__close-icon {
  line-height: 26px !important;
}
.changeSearch /deep/ #tab-xzqh {
  width: 80px;
  background: rgba(36, 105, 241, 0.2);
  border-right: 2px solid #fff;
  text-align: center;
  padding: 0 !important;
}
.changeSearch /deep/ #tab-jwd {
  width: 80px;
  background: rgba(36, 105, 241, 0.2);
  text-align: center;
  padding: 0 !important;
}
.changeSearch /deep/ .dataCloudiness .el-slider__runway {
  margin: 1px auto;
}
.searchBtnBox /deep/ .changeBtn.el-button {
  font-size: 16px !important;
  padding: 10px !important;
}
.searchBtnBox /deep/ .searchBtn.el-button {
  font-size: 20px !important;
  padding: 10px !important;
}
.backHome /deep/ .backHomeBtn.el-button {
  font-size: 20px !important;
  padding: 10px !important;
}
</style>
